import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useNavigate } from 'react-router-dom'
import { useScreenSize } from '../../../../sharedComponents/src/hooks/useScreenSize'
import { useStoreState } from '../../../../store/hooks'

type DailyPuzzleButtonsProps = {
    children?: React.ReactNode
}

const DailyPuzzleButtons: React.FC<DailyPuzzleButtonsProps> = ({ children }) => {
    const navigate = useNavigate()
    const puzzleState = useStoreState((state) => state.dailyPuzzleViewV2.puzzleState)
    const { isMobile } = useScreenSize()

    const buttonSize = isMobile ? 'medium' : 'large'
    const placeholderHeight = isMobile ? '36px' : '48px'

    if (puzzleState === true) {
        return (
            <Stack direction="row" gap={1} sx={{ alignSelf: 'stretch' }}>
                <Button
                    onClick={() => navigate('/puzzles')}
                    variant="outlined"
                    size={buttonSize}
                    sx={{ px: 0.5 }}
                    fullWidth
                >
                    Puzzle Practice
                </Button>
                <Button
                    onClick={() => navigate('/puzzle-quest')}
                    variant="contained"
                    size={buttonSize}
                    sx={{ px: 0.5 }}
                    fullWidth
                >
                    Puzzle Quest
                </Button>
            </Stack>
        )
    }

    if (children) {
        return children
    }

    return <Box sx={{ height: placeholderHeight }} />
}

export default DailyPuzzleButtons
